import "inert-polyfill";
import "intersection-observer";
import "lazysizes";
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
